import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const OrderConfirmation: React.FC = () => {
  return (
    <div className="min-h-screen bg-midnight py-12">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-6">
            <CheckCircle className="w-16 h-16 text-success-500" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-4">Order Confirmed!</h1>
          <p className="text-lg text-gray-300">Thank you for your order. We'll notify you when your video is ready.</p>
        </div>
        
        <div className="card">
          <h2 className="text-xl font-semibold text-black mb-4">Order Details</h2>
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-white">Order Number:</span>
              <span className="font-semibold text-black">#BC12345</span>
            </div>
            <div className="flex justify-between">
              <span className="text-white">School:</span>
              <span className="text-black">Lincoln High School</span>
            </div>
            <div className="flex justify-between">
              <span className="text-white">Occasion:</span>
              <span className="text-black">Birthday</span>
            </div>
            <div className="flex justify-between">
              <span className="text-white">Recipient:</span>
              <span className="text-black">John Smith</span>
            </div>
            <div className="flex justify-between">
              <span className="text-white">Total:</span>
              <span className="font-semibold text-black">$50.00</span>
            </div>
          </div>
          
          <div className="mt-8 p-4 bg-goldie border-2 border-black">
            <h3 className="font-semibold text-black mb-2">What's Next?</h3>
            <p className="text-white text-sm">
              The band will create your personalized video and send it to your email address. 
              You'll receive a notification when it's ready!
            </p>
          </div>
          
          <div className="mt-6 flex flex-col sm:flex-row gap-4">
            <Link
              to="/"
              className="btn-outline text-center"
            >
              Return Home
            </Link>
            <button className="btn-primary">
              Order Another Video
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation; 